import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom'
import App from './App';
import Checkout from './Checkout';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import ThankYou from './ThankYou';

class Main extends React.Component{
    render(){
        return(
            <HashRouter>
                <Routes >
                    <Route path='/' element={<App />}/>
                    <Route path='/checkout' element={<Checkout />}/>
                    <Route path='/thank-you' element={<ThankYou />}/>
                    <Route path='*' element={<App />}/>
                </Routes>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    bodyClassName="toastBody"
                    newestOnTop={true}
                    hideProgressBar={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    />
            </HashRouter>
        )
    }
};

export default Main;